import { createNewCommentElement } from "/commentaries/new_coment.js";
import { getCommentariesByIdList } from "/commentaries/get_functions.js";
import { createElement } from "/elements_functions/new_elements.js";
import { formatDateForPost } from "/misc_functions/date_functions.js";
import {insertImageValue} from '/set_pics_functions/set_pic_functions.js';
import { createUserProfilePicNameAndUsernameGroup } from "/user_functions/create_elements.js";
import { makeNewButton, makeNewButtonAffectingDifferentElement } from '/buttons_functions/custom_button_functions.js';

export function createCommentary(commentaryInfo, initiationFunctionsObject=null) {
    const commentaryElement = createElement('div', null, ['comment']);

    const userShortInfoGroup = createUserProfilePicNameAndUsernameGroup(commentaryInfo.authorInfo);

    const message = createElement('p', null, ['comment-message']);
    message.innerText = commentaryInfo.message;

    const dateAndButtons = createElement('div', null, ['comment-date-and-buttons']);

    const date = createElement('p', null, ['comment-date']);
    date.innerText = formatDateForPost(new Date(commentaryInfo.date));

    const replyButton = createElement('button', null, ['comment-reply-button']);
    replyButton.innerText = 'Reply';

    const repliesSection = createRepliesSection(commentaryInfo.repliesIds, initiationFunctionsObject);

    replyButton.addEventListener('click', () => {

        const originalSubmitReply = initiationFunctionsObject.submitReply;
        const replyWindowElement = createNewCommentElement((message, newReplyElement) =>
            originalSubmitReply(message, newReplyElement, commentaryInfo.id), initiationFunctionsObject.newReplyInitFunction);

        const cancelButton = replyWindowElement.cancelButton;

        cancelButton.addEventListener('click', () => {
            replyWindowElement.remove();
            replyButton.classList.remove('hidden-info');
        });

        repliesSection.repliesSectionComments.insertAdjacentElement('afterbegin', replyWindowElement);

        replyButton.classList.add('hidden-info');
    });
    makeNewButton(replyButton, 'white', 'light-black', null, 'darken', null);

    dateAndButtons.append(date, replyButton);

    commentaryElement.append(userShortInfoGroup);
    commentaryElement.append(message);
    commentaryElement.append(dateAndButtons);
    commentaryElement.append(repliesSection);

    commentaryElement.userShortInfoGroup = userShortInfoGroup;
    commentaryElement.userProfilePic = userShortInfoGroup.userProfilePic;
    commentaryElement.userNameAndUsername = userShortInfoGroup.userNameAndUsername;
    commentaryElement.message = message;
    commentaryElement.dateAndButtons = dateAndButtons;
    commentaryElement.date = date;
    commentaryElement.replyButton = replyButton;
    commentaryElement.repliesSection = repliesSection;

    if(initiationFunctionsObject!==null && initiationFunctionsObject.commentaryInitFunction instanceof Function)
        initiationFunctionsObject.commentaryInitFunction(commentaryElement);

    return commentaryElement;
}

function createRepliesSection(repliesIds, initiationFunctionsObject=null) {
    const repliesSection = createElement('div', null, ['comment-reply-section']);
    const repliesSectionButton = createElement('div', null, ['comment-reply-section-button']);
    const repliesSectionButtonRectangle = createElement('div', null, ['comment-reply-section-button-rectangle']);
    const repliesSectionComments = createElement('div', null, ['comment-reply-section-comments']);

    repliesSectionComments.loadedRepliesCount = 0;
    
    if(repliesIds!==null && repliesIds.length>0) {
        const repliesToLoad = repliesIds.slice(0, 4);
        const repliesToLoadLater = repliesIds.slice(4);
        
        const loadRepliesButton = createLoadRepliesButton(repliesToLoad, repliesToLoadLater, repliesSectionComments, initiationFunctionsObject);
        
        repliesSectionComments.append(loadRepliesButton);

        repliesSection.loadRepliesButton = loadRepliesButton;
        repliesSectionComments.borderButton = loadRepliesButton;
        repliesSectionComments.sectionCollapsed=true;
    }

    repliesSectionButton.append(repliesSectionButtonRectangle);
    repliesSectionButton.addEventListener('click', () => clickRepliesBorder(repliesSection));
    makeNewButtonAffectingDifferentElement(repliesSectionButton, repliesSectionButtonRectangle, 'rgb(128, 128, 128)', null, null, 'darken', null);

    repliesSectionButton.repliesSectionButtonRectangle = repliesSectionButtonRectangle;

    repliesSection.append(repliesSectionButton);
    repliesSection.append(repliesSectionComments);

    repliesSection.repliesSectionButton = repliesSectionButton;
    repliesSection.repliesSectionComments = repliesSectionComments;

    return repliesSection;
}

function clickRepliesBorder(repliesSection) {
    const repliesSectionComments = repliesSection.repliesSectionComments;

    console.log(repliesSectionComments.loadRepliesButton, "loadRepliesButton");
    console.log(repliesSectionComments.sectionCollapsed, "sectionCollapsed");
    

    if(repliesSectionComments.sectionCollapsed===true) {
        if(repliesSectionComments.borderButton!==null)
            repliesSectionComments.borderButton.click();
        repliesSectionComments.sectionCollapsed=false;
    } else {
        const uncollapseButton = createElement('button', null, ['comment-load-replies-button']);
        
        const repliesSectionComments = repliesSection.repliesSectionComments;
        uncollapseButton.innerText = `+${repliesSectionComments.loadedRepliesCount} replies`;

        const repliesSectionCommentsChildren = repliesSectionComments.children;

        for(let i of repliesSectionCommentsChildren) {
            i.classList.add('hidden-info');
        }

        uncollapseButton.addEventListener('click', () => {
            for(let i of repliesSectionCommentsChildren) {
                i.classList.remove('hidden-info');
            }

            repliesSectionComments.sectionCollapsed=false;

            uncollapseButton.remove();
        });

        repliesSectionComments.borderButton = uncollapseButton;

        repliesSectionComments.append(uncollapseButton);

        repliesSectionComments.sectionCollapsed=true;
    }

}

function createLoadRepliesButton(repliesToLoad, repliesToLoadLater, insertElement, initiationFunctionsObject=null) {
    const loadRepliesButton = createElement('button', null, ['comment-load-replies-button']);
    loadRepliesButton.innerText = `+${repliesToLoad.length} replies`;

    loadRepliesButton.addEventListener('click', () => {
        loadRepliesAndInsert(repliesToLoad, repliesToLoadLater, insertElement, initiationFunctionsObject).then(() => {
            loadRepliesButton.remove();
        });
        insertElement.sectionCollapsed=false;
    });

    makeNewButton(loadRepliesButton, 'white', 'light-black', null, 'darken', null);

    if(initiationFunctionsObject!==null && initiationFunctionsObject.loadRepliesButtonInitFunction instanceof Function)
        initiationFunctionsObject.loadRepliesButtonInitFunction(loadRepliesButton);

    return loadRepliesButton;
}

async function loadRepliesAndInsert(repliesToLoad, repliesToLoadLater, insertElement, initiationFunctionsObject) {
    const commentariesInfo = await getCommentariesByIdList(repliesToLoad);
    insertElement.borderButton = null;
    
    const commentariesElements = [];

    if(commentariesInfo!==null && commentariesInfo.length>0) {
        for(let i of commentariesInfo) {
            const commentary = createCommentary(i, initiationFunctionsObject);

            commentariesElements.push(commentary);
        }

        insertElement.loadedRepliesCount = insertElement.loadedRepliesCount + commentariesInfo.length;
        insertElement.sectionCollapsed=false;
    }

    console.log("load commentariesInfo", commentariesInfo);
    

    if(repliesToLoadLater!==null && repliesToLoadLater.length>0) {
        const nextRepliesToLoad = repliesToLoadLater.slice(0, 4);
        const nextRepliesToLoadLater = repliesToLoadLater.slice(4);

        const loadNextRepliesButton = createLoadRepliesButton(nextRepliesToLoad, nextRepliesToLoadLater, insertElement, initiationFunctionsObject);

        commentariesElements.push(loadNextRepliesButton);

        insertElement.borderButton = loadNextRepliesButton;
    }

    if(commentariesElements.length>0)
        insertElement.append(...commentariesElements);

}